import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";

import { Point, BLEND_MODES, Container } from "pixi.js";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { Bounce, Power0, TimelineMax, TweenLite } from "gsap";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { SanSymbolData } from "../../../engine/Symbol/SanSymbolData";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { TextStyleConfig } from "../../../translation/TextStyleConfig";
import { Revealer } from "../revealer/Revealer";
import { RevealerManager } from "../revealer/RevealerManager";

export class ReelAnimationState extends StateHandler{
    
    public static readonly ATTENTION:string = "FX_ReelAttention_A/Loop";
    
    // SingleTextures
    public static readonly REEL_FEATURE_ATTENTION:string = "Reel_Attention";
}

export class ReelAnimationController extends Container {

    private _areaAnimation:Sequence;
    private _flashLand:Sequence;
    private _reelID:number = 0;

    private _timeline:TimelineMax;
    private tlFlashLoop:TimelineMax;
    private tlAtt:TimelineMax;

    private stopFlash:boolean = false;

    private plusOne:PIXI.Text;
    private plusOneScale:PIXI.Point = new PIXI.Point(1.45,1.45);

    private hotFlashRow:number = -1;

    private graphicArea:PIXI.Graphics;
    private multValue:PIXI.Text;

    public get ReelID():number{
        return this._reelID;
    }

    constructor(reelID:number){
        super();
        this._reelID = reelID;
        this.init();
    }

    private init():void{

        this._areaAnimation = this.addSeq(GameResources.getTextures("Blink_Reel"));
        this._flashLand = this.addSeq(GameResources.getTextures("Blink_Reel"));

        this.plusOne = this.createTextObject("+1", TextStyleConfig.BAR_REVEALER_TEXT);
        this.plusOne.scale = this.plusOneScale;
    }  

    private createTextObject(text:string,style:any): PIXI.Text {
        const textObj = new PIXI.Text(text,style);
        textObj.anchor.set(0.5, 0.5);
        textObj.visible = false;
        this.addChild(textObj);
        return textObj;
    }

    private _splitMult_tl:TimelineMax;
    public splitMult(active:boolean):TimelineMax{

        this._splitMult_tl = Helper.timeLineKiller(this._splitMult_tl,new TimelineMax({
            onStart:() => {
                SanEngineManager.getReel(this.ReelID).splitFsLand(0.25);
                if(active) this.graphicArea.visible = true;
            },
            onComplete:() => {
                if(active){
                    this._splitMult_tl = Helper.timeLineKiller(this._splitMult_tl, new TimelineMax({repear:-1}));
                    this._splitMult_tl.to(this.graphicArea,0.25,{alpha:0.5});
                    this._splitMult_tl.to(this.graphicArea,0.25,{alpha:1});
                    this._splitMult_tl.play();
                }
                else
                    this.graphicArea.visible = false;
            }
        }));

        if(active){
            this._splitMult_tl.staggerTo([ this.graphicArea,this.multValue],0.25,{alpha:1},0);
            this._splitMult_tl.fromTo(this.multValue.scale,0.25/2,{x:2,y:2},{x:3,y:3},0);
            this._splitMult_tl.to(this.multValue.scale,0.25/2,{x:2,y:2},0.25/2);
        }else{
            this._splitMult_tl.staggerTo([ this.graphicArea,this.multValue],0.25,{alpha:0},0);
            this._splitMult_tl.to(this.multValue.scale,0.25/2,{x:0,y:0},0.25/2);
        }

        return this._splitMult_tl;
    }

    public playLand(intense:number = 1):TimelineMax{
        return this._flashLand.playAnimation({
            onStart:() => {this._flashLand.visible = true, this._flashLand.alpha = intense },
            onCompleteCallback:() => this._flashLand.visible = false }
        );
    }

    private xWayAntipi:TimelineMax;
    public playXwayAntipi():TimelineMax{
        this.xWayAntipi = Helper.timeLineKiller(this.tlPlus,new TimelineMax({}))

        return this.xWayAntipi;
    } 

    private tlPlus:TimelineMax;
    public playPlusScatter(amount:number = 1):TimelineMax{

        this.tlPlus = Helper.timeLineKiller(this.tlPlus,new TimelineMax({}))
        this.tlPlus.add(SanEngineManager.getReel(this.ReelID).splitFsLand(1,amount),0)

        return this.tlPlus;
    } 

    public stopPlusScatter(force:boolean = false):void{
        this.tlPlus = Helper.timeLineKiller(this.tlPlus,new TimelineMax());

        SanEngineManager.getReel(this.ReelID).stopFsLand(0.15);
        
        RevealerManager.getTopBar(this.ReelID).specialBarStop(0.15,force)
        RevealerManager.getBotBar(this.ReelID).specialBarStop(0.15,force)
    } 


    public removePlusOne():void{
        if(this.plusOne.visible){
            this.tlPlus = Helper.timeLineKiller(this.tlPlus,new TimelineMax({
                // onComplete:() => this.plusOne.visible = false,
            }))
            const startPosY:number = this.plusOne.y;
            this.tlPlus.to(this.plusOne.position,0.5, {y: startPosY - 125 },0);
            this.tlPlus.to(this.plusOne,0.5, {alpha: 0},0.15);
        }
    } 

    private addSeq(texture:PIXI.Texture[]):Sequence{
        const seq = this.addChild(Sequence.createSequence(texture));
        seq.alpha = 1;
        seq.visible = false;
        seq.blendMode = BLEND_MODES.ADD;
        return seq;
    }

    public resetFlashPos():void{
        this.hotFlashRow = -1;
    }

    public hotFlashPos(pos:number | number[]):number{
        if(Array.isArray(pos) && pos.indexOf(this.hotFlashRow) >= 0) return this.hotFlashRow;
        else return this.hotFlashRow == pos ? this.hotFlashRow : -1;
    }

    // private alphaTl:TimelineMax;
    // public hotFlashAlpha(alpha:number,duration:number){
    //     this.alphaTl = <TimelineMax>Helper.timeLineKiller(this.alphaTl,new  TimelineMax());
    //     const fromAlpha:number = this.HotFXSymbol.alpha;
    //     this.alphaTl.fromTo(this.HotFXSymbol,duration,{alpha:fromAlpha},{alpha});
    //     this.alphaTl.play();
    // }

    // public flashSingelHotSymbol(rowID:number):TimelineMax{
    //     this.tlFlashLoop = Helper.timeLineKiller(this.tlFlashLoop, new TimelineMax());

    //     // const toPosition: Point = reelC.getCurrentStatePositionMap(item.cont)[conf.to.row + reelC.overflowDirection];

    //     const statPos:PIXI.Point = SanEngineManager.getReel(this._reelID).getCurrentStatePositionMap(this)[rowID];
    //     this.HotSymbol.position = statPos; 
    //     this.HotFXSymbol.position = statPos;
    //     this.HotLightSymbol.position = statPos;

    //     this.HotSymbol.position = MathHelper.pointSub(<PIXI.Point>this.HotSymbol.position, <PIXI.Point>this.position);
    //     this.HotFXSymbol.position = MathHelper.pointSub(<PIXI.Point>this.HotFXSymbol.position, <PIXI.Point>this.position);
    //     this.HotLightSymbol.position = MathHelper.pointSub(<PIXI.Point>this.HotLightSymbol.position, <PIXI.Point>this.position);

    //     this.HotFXSymbol.stop();
       
    //     return this.HotFXSymbol.playAnimation({ 
    //         onStart:() => { 
    //             this.HotFXSymbol.visible = true;
    //             this.HotFXSymbol.alpha = 1;

    //         }, onUpdate: () => { 
    //             var upAlpha:number = 1-this.HotFXSymbol.timeline!.totalProgress();
    //             this.HotFXSymbol.alpha = upAlpha;
    //             this.HotSymbol.alpha = upAlpha;
    //         },
    //         onCompleteCallback:() => {
    //             this.HotLightSymbol.visible = false;
    //             this.HotSymbol.visible = false;
    //         }
    //     });
    // }

    // public flashHotSymbol(active:boolean,rowID?:number):TimelineMax{
    //     this.tlFlashLoop = Helper.timeLineKiller(this.tlFlashLoop, new TimelineMax());

    //     if(active) {
    //         this.hotFlashRow = rowID!;
    //         const sym:SanSpriteSymbol = SanEngineManager.getReel(this._reelID).getSymbol(rowID!)!;
    //         this.HotSymbol.position = Helper.copyLocalPosition(this.HotSymbol, sym);
    //         this.HotFXSymbol.position = Helper.copyLocalPosition(this.HotFXSymbol, sym);
    //         this.HotLightSymbol.position = Helper.copyLocalPosition(this.HotLightSymbol, sym);

    //         // const scaledHeight:number = SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * SanEngineManager.dim.scale.y;

    //         this.HotSymbol.position = MathHelper.pointSub(<PIXI.Point>this.HotSymbol.position, <PIXI.Point>this.position);
    //         this.HotFXSymbol.position = MathHelper.pointSub(<PIXI.Point>this.HotFXSymbol.position, <PIXI.Point>this.position);
    //         this.HotLightSymbol.position = MathHelper.pointSub(<PIXI.Point>this.HotLightSymbol.position, <PIXI.Point>this.position);

    //         this.HotFXSymbol.stop();

    //         this.tlFlashLoop.add(() => {
    //             this.HotSymbol.visible = true;
    //             this.HotLightSymbol.visible = true;
               
    //             sym.changeState({state:ReelSymbolStates.SPIN})
    //         });

    //         this.tlFlashLoop.fromTo(this.HotLightSymbol,0.5,{alpha: 1},{alpha: 0},0);
    //         this.tlFlashLoop.fromTo(this.HotSymbol,0.5,{alpha: 1},{alpha: 0},0);

    //         // this.tlFlashLoop.fromTo(this.HotFXSymbol,0.25,{alpha:0},{alpha: 1}, 0);
    //         this.tlFlashLoop.add(this.HotFXSymbol.playAnimation({ 
    //             onStart:() => { 
    //                 this.HotFXSymbol.visible = true;
    //                 this.HotFXSymbol.alpha = 1;

    //                 this.HotLightSymbol.visible = false;
    //                 this.HotSymbol.visible = false;
    //             },
    //             onCompleteCallback: () => this.HotFXSymbol.playAnimation({repeat: -1}) }),
    //         0);
         
    //     }else{
    //         this.tlFlashLoop.fromTo(this.HotFXSymbol,0.25,{alpha:1},{alpha: 0});
    //         this.tlFlashLoop.add(() => {
    //             this.HotFXSymbol.stop();
    //             this.HotFXSymbol.visible = false;
    //         })
    //     }
    //     return this.tlFlashLoop;
    // }

    public graphSingelFlash(duration:number = 0.3):TimelineMax{
        this._timeline = Helper.timeLineKiller(this._timeline, new TimelineMax({onStart:() => this._areaAnimation.visible = true, onComplete:() => this._areaAnimation.visible = false}));
        this._timeline.add([
            TweenLite.fromTo(this._areaAnimation,duration,{alpha:1},{alpha:0}),
        ]);
        return this._timeline;
    }

    public graphFlash(active:boolean, maxAlph:number = 1):void{
        if(active){
            this.stopFlash = false;
            this.tlAtt =  Helper.timeLineKiller(this.tlAtt, new TimelineMax({
                repeat: -1,
                repeatDelay:0,
                onStart:() => this._areaAnimation.visible = true,
                onRepeat:() => {
                    if(this.stopFlash){
                        this._areaAnimation.alpha = 0;
                        this._areaAnimation.visible = false;
                        Helper.timeLineKiller(this.tlAtt);
                    }
                },
            }))
            this.tlAtt.fromTo(this._areaAnimation,0.125,{alpha:0},{alpha:maxAlph});
            this.tlAtt.to(this._areaAnimation,0.125,{alpha:0});
            this.tlAtt.play();
        }else 
            this.stopFlash = true;
    }

    public overlayGraphicAlpha(from:number = 0, to:number = 0, duration:number = 0.2):TimelineMax{
        this._timeline = Helper.timeLineKiller(this._timeline, new TimelineMax());
        this._timeline.fromTo(this._areaAnimation,duration,{alpha:from},{alpha:to});
        return this._timeline;
    }

    public onResize(){
        const scaledHeight:number = SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * SanEngineManager.dim.scale.y;
        this.position = MathHelper.pointAdd(SanEngineManager.getReelPos(this._reelID), new Point(0, scaledHeight));
        this.scale = SanEngineManager.dim.scale;
    }
}